<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { Readable } from "svelte/store";
import { getFirstSourceStore, getTemplatedElementDataFromSource, } from "../../../utilities";
import ResultCard from "../common/ResultCard.svelte";
import { Popup } from "framework7-svelte";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import { onMount } from "svelte";
import { JanusSignonManagerToken, SSOResult } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { resolveUrl } from "../../../../../js/url";
import { YinzCamLoyaltyServer, YinzCamLoyaltyServerToken } from 'yinzcam-loyalty';
import _ from 'lodash';
export let element;
export let sources;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
const loyaltyServer = getToken(ROOT, YinzCamLoyaltyServerToken);
$: source = getFirstSourceStore($sources);
$: backgroundColor = String(((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.backgroundColor) || "");
$: backgroundImage = String(((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.backgroundImage) || "");
$: fontFace = String(((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.fontFace) || "");
$: imageWrapperStyle = String(((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.imageWrapperStyle) || "width: 100%;");
$: imageWrapperImgStyle = String(((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.imageWrapperImgStyle) || "width: 100%;");
$: buttonBorderRadius = String(((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.buttonBorderRadius) || "20px");
$: successHeaderImage = String(((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.successHeaderImage) || "");
$: titleColor = String(((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.titleColor) || "");
$: descriptionColor = String(((_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.descriptionColor) || "");
$: successTitle = String(((_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k.successTitle) || "");
$: successDescription = String(((_l = element === null || element === void 0 ? void 0 : element.data) === null || _l === void 0 ? void 0 : _l.successDescription) || "");
$: successButtonBackground = String(((_m = element === null || element === void 0 ? void 0 : element.data) === null || _m === void 0 ? void 0 : _m.successButtonBackground) || "");
$: successButtonColor = String(((_o = element === null || element === void 0 ? void 0 : element.data) === null || _o === void 0 ? void 0 : _o.successButtonColor) || "");
$: successButtonText = String(((_p = element === null || element === void 0 ? void 0 : element.data) === null || _p === void 0 ? void 0 : _p.successButtonText) || "");
$: failHeaderImage = String(((_q = element === null || element === void 0 ? void 0 : element.data) === null || _q === void 0 ? void 0 : _q.failHeaderImage) || "");
$: failTitle = String(((_r = element === null || element === void 0 ? void 0 : element.data) === null || _r === void 0 ? void 0 : _r.failTitle) || "");
$: failDescription = String(((_s = element === null || element === void 0 ? void 0 : element.data) === null || _s === void 0 ? void 0 : _s.failDescription) || "");
$: failButtonBackground = String(((_t = element === null || element === void 0 ? void 0 : element.data) === null || _t === void 0 ? void 0 : _t.failButtonBackground) || "");
$: failButtonColor = String(((_u = element === null || element === void 0 ? void 0 : element.data) === null || _u === void 0 ? void 0 : _u.failButtonColor) || "");
$: failButtonText = String(((_v = element === null || element === void 0 ? void 0 : element.data) === null || _v === void 0 ? void 0 : _v.failButtonText) || "");
$: successUrl = resolveUrl(String(((_w = element === null || element === void 0 ? void 0 : element.data) === null || _w === void 0 ? void 0 : _w.successUrl) || ""));
$: failUrl = resolveUrl(String(((_x = element === null || element === void 0 ? void 0 : element.data) === null || _x === void 0 ? void 0 : _x.failUrl) || ""));
$: scannerHeight = ((_y = element === null || element === void 0 ? void 0 : element.data) === null || _y === void 0 ? void 0 : _y.scannerHeight) || 250;
$: scannerWidth = ((_z = element === null || element === void 0 ? void 0 : element.data) === null || _z === void 0 ? void 0 : _z.scannerWidth) || 250;
$: scanResult = null;
$: loginRedirectPage = ((_0 = element === null || element === void 0 ? void 0 : element.data) === null || _0 === void 0 ? void 0 : _0.loginRedirectPage) || null;
let scanning = false;
let html5Qrcode;
let pointsEarned = 0;
onMount(init);
function extractCodeFromUrl(urlString) {
    return new URL(urlString).searchParams.get('externalCode');
}
function isValidHttpUrl(urlString) {
    let url;
    try {
        url = new URL(urlString);
    }
    catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}
function init() {
    //If we are navigating back to the CodeScanner page, remove the externalCode param if it exists.
    window.addEventListener("load", (event) => {
        let newUrl = new URL(window.location.href);
        newUrl.searchParams.delete("externalCode");
        let step = 0;
        history.replaceState({ step }, '', newUrl.href);
    });
    const externalCode = extractCodeFromUrl(window.location.href);
    if (externalCode) {
        //alert("got external code: " + externalCode);
        const signonStatus = signonManager.getStatus();
        if (signonStatus.loggedIn && signonStatus.serviceTicket) {
            setTimeout(() => {
                checkCode(externalCode);
            }, 0);
        }
        else {
            window.localStorage.setItem('ssoRedirectAfterLogin', window.location.href);
            if (loginRedirectPage) {
                resolveUrl(loginRedirectPage).func();
            }
            else {
                resolveUrl('/').func();
            }
        }
    }
    else {
        html5Qrcode = new Html5Qrcode("reader");
        start();
    }
    return () => __awaiter(this, void 0, void 0, function* () {
        yield stop();
    });
}
function start() {
    html5Qrcode.start({ facingMode: "environment" }, {
        fps: 10,
        qrbox: { width: scannerWidth, height: scannerHeight },
        formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE]
    }, onScanSuccess);
    scanning = true;
}
function stop() {
    return __awaiter(this, void 0, void 0, function* () {
        yield html5Qrcode.stop();
        scanning = false;
    });
}
function checkCode(code) {
    return __awaiter(this, void 0, void 0, function* () {
        console.log('checkCode', code);
        try {
            const pcsResult = yield loyaltyServer.postPointcodeSubmit(code, 'QR');
            console.log('PointcodeSubmit RESULT', pcsResult);
            const asResult = yield loyaltyServer.postAppSubmitSync("Apply Loyalty Code", { campaign: code });
            console.log('AppSubmit RESULT', asResult);
            if (!(asResult === null || asResult === void 0 ? void 0 : asResult.Achievement) || asResult.Achievement.length === 0) {
                throw new Error('The code did not match any achievements.');
            }
            pointsEarned = Math.max.apply(Math, asResult.Achievement.map(function (a) { return a.PointValue; }));
            scanResult = true;
        }
        catch (e) {
            onScanFailure(e);
        }
    });
}
function onScanSuccess(decodedText, decodedResult) {
    return __awaiter(this, void 0, void 0, function* () {
        console.log('onScanSuccess', decodedText, decodedResult);
        if (!scanning) {
            return;
        }
        scanning = false;
        let restartScan = true;
        try {
            const code = extractCodeFromUrl(decodedText);
            if (code) {
                restartScan = false;
                yield checkCode(code);
            }
            else if (isValidHttpUrl(decodedText)) {
                // let the browser sort it out
                restartScan = false;
                window.location.href = decodedText;
            }
            else {
                console.warn("code not found in scanned text");
            }
        }
        catch (e) {
            console.warn("exception when scanning code", e);
        }
        if (restartScan) {
            scanning = true;
        }
    });
}
function onScanFailure(error) {
    console.warn(onScanFailure, error);
    scanResult = false;
}
</script>

<CardBase {element}>
  <div class="code-scanner">
    <Popup
      opened={scanResult === true}
      onPopupClosed={() => (scanResult = null)}
      swipeToClose={false}
      class="result-popup"
    >
      <ResultCard
        {backgroundColor}
        {fontFace}
        headerImage={successHeaderImage}
        {titleColor}
        {descriptionColor}
        title={successTitle}
        description={_.replace(successDescription, '{{pointsEarned}}', pointsEarned.toString())}
        buttonBackground={successButtonBackground}
        {successButtonColor}
        {successButtonText}
        backgroundImage={backgroundImage}
        imageWrapperStyle={imageWrapperStyle}
        imageWrapperImgStyle={imageWrapperImgStyle}
        buttonBorderRadius={buttonBorderRadius}
        onButtonClick={() => { scanResult = null; successUrl.func(); } }
      />
    </Popup>
    <Popup
      opened={scanResult === false}
      onPopupClosed={() => (scanResult = null)}
      swipeToClose={false}
      class="result-popup"
    >
      <ResultCard
        {backgroundColor}
        {fontFace}
        headerImage={failHeaderImage}
        {titleColor}
        {descriptionColor}
        title={failTitle}
        description={failDescription}
        buttonBackground={failButtonBackground}
        successButtonColor={failButtonColor}
        successButtonText={failButtonText}
        backgroundImage={backgroundImage}
        imageWrapperStyle={imageWrapperStyle}
        imageWrapperImgStyle={imageWrapperImgStyle}
        buttonBorderRadius={buttonBorderRadius}
        onButtonClick={() => { scanResult = null; failUrl.func(); }}
      />
    </Popup>
    <div class="qrcode">
      <reader id="reader" />
    </div>
  </div>
</CardBase>

<style type="text/css">*,
  *:before,
  *:after {
  box-sizing: border-box;
}

:global(.result-popup) {
  background: transparent;
  display: flex !important;
  align-items: center;
  justify-content: center;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.qrcode {
  background: rgba(51,51,51,0.66667);
  padding: 57px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

#reader {
  width: 390px;
}</style>
